import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { verificationService } from "../../verification/shared/services/verification.service";
import { IMateriallyAccountableEmployeeDto } from "../shared/dtos/materially-accountable-employee.dto";
import { MateriallyAccountableEmployeeListSchema } from "../shared/dtos/materially-accountable-employee.schema";
import { TMateriallyAccountableEmployeesFilter } from "../shared/interfaces/materially-accounteble-employees-filter";
import { MateriallyAccountableEmployee } from "../shared/models/materially-accountable-employee";

export const materiallyAccountableEmployeesSlice = createApi({
  reducerPath: "api-materially-accountable-employees",
  tagTypes: ["MateriallyAccountableEmployees"],
  baseQuery,
  endpoints: (build) => ({
    materiallyAccountableEmployeeList: build.query<
      MateriallyAccountableEmployee[],
      TMateriallyAccountableEmployeesFilter
    >({
      query: (filter) => ({
        url: "MateriallyAccountableEmployees",
        params: { farmId: filter.farmId },
      }),
      providesTags: ["MateriallyAccountableEmployees"],
      transformResponse: (data: IMateriallyAccountableEmployeeDto[]) =>
        verificationService
          .check({
            cacheId: "MateriallyAccountableEmployeeListSchema",
            schema: MateriallyAccountableEmployeeListSchema,
            message: "Невалидный ответ сервера (MateriallyAccountableEmployees)",
          })(data)
          .map((dto) => {
            const model = new MateriallyAccountableEmployee(dto.id);
            model.updateFromDto(dto);
            return model;
          }),
    }),
  }),
});

export const { useMateriallyAccountableEmployeeListQuery } =
  materiallyAccountableEmployeesSlice;
